import { Component, OnInit, Input, Inject, inject, DestroyRef, signal } from '@angular/core';
import { CustomField, DATE_OPTIONS, DateOptions, LottoItem, LottosWalletItem, RewardsWalletQuery } from '@fgb/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { Location } from '@angular/common';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { DateTime } from 'luxon';

type CustomFieldView = CustomField & {
  isDate: boolean;
  DisplayValue?: string;
};

@Component({
  selector: 'fgbcl-lottos-wallet-details',
  templateUrl: './lottos-wallet-details.component.html',
  styleUrls: ['./lottos-wallet-details.component.scss'],
})
export class LottosWalletDetailsComponent implements OnInit {
  @Input() lottoId: number;
  @Input() lottoItem: LottoItem;
  showPts: boolean = false;
  purchasedItem: LottosWalletItem;
  customFields: CustomFieldView[] = [];
  screenType = ScreenType;
  groupedItem: any;
  totalPoints: number = 0;
  detroyRef = inject(DestroyRef);
  desktopOptions: OwlOptions = {
    dots: true,
    margin: 8,
    pullDrag: false,
    autoWidth: true,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    responsive: {
      0: { items: 1, autoWidth: true },
      540: { items: 1, autoWidth: true },
      740: { items: 1 },
    },
  };

  mobileOptions: OwlOptions = {
    dots: true,
    margin: 8,
    pullDrag: false,
    autoWidth: true,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    responsive: {
      0: { items: 1, autoWidth: true },
      540: { items: 2, autoWidth: false },
      740: { items: 3 },
    },
  };
  expired = signal(false);

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private rewardsWalletQuery: RewardsWalletQuery,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id') || '0';
    this.rewardsWalletQuery
      .selectRewardWalletItem(id)
      .pipe(map((item) => item as LottosWalletItem))
      .pipe(
        switchMap((lotto) =>
          this.rewardsWalletQuery.selectItemsByGroupId(lotto?.GroupId).pipe(map((group) => ({ lotto, group })))
        ),
        takeUntilDestroyed(this.detroyRef)
      )
      .subscribe(({ lotto, group }) => {
        if (!lotto) return;
        this.purchasedItem = lotto as LottosWalletItem;
        this.customFields = (this.purchasedItem.CustomFields as CustomFieldView[]).map((field) => {
          const dt = DateTime.fromFormat(field.DisplayValue || '', 'yyyy-MM-dd');
          return { ...field, isDate: dt.isValid };
        });

        const isExpired = DateTime.fromISO(this.purchasedItem.ExpireDate as string, { zone: 'utc' }) < DateTime.utc();
        this.expired.set(isExpired);

        this.groupedItem = group;
        this.totalPoints = this.groupedItem?.items.reduce((acc: number, item: any) => acc + item.PointValue, 0);
      });
  }

  backToWallet() {
    this.location.back();
  }
}
